import { render } from "./timeline-widget.vue?vue&type=template&id=3e72e920"
import script from "./timeline-widget.vue?vue&type=script&lang=ts"
export * from "./timeline-widget.vue?vue&type=script&lang=ts"
script.render = render

export default script